import { SETTINGS as quickbooks } from "views/Configuration/settings/connections/quickbooks";
import { SETTINGS as shipstation } from "views/Configuration/settings/connections/shipstation";

export const SETTINGS = {
  quickbooks,
  shipstation,
};
